export class LocalChecker {
  static MULTIPLICITY_ONE = "ONE";
  static MULTIPLICITY_MANY = "MANY";
  multiplicity: string = LocalChecker.MULTIPLICITY_ONE || LocalChecker.MULTIPLICITY_MANY;
  type: string;
  refType?: string;
  componentKey?: string;
  // Ajout temporaire pour compatibilité tests/types
  pattern?: string;
  params?: any;

  constructor(multiplicity: string, type: string, refType: string = "", componentKey: string = "", pattern?: string, params?: any) {
    this.multiplicity = multiplicity;
    this.type = type;
    this.refType = refType;
    this.componentKey = componentKey;
    this.pattern = pattern;
    this.params = params;
  }
}
